import { render, staticRenderFns } from "./manage-diagnosis.html?vue&type=template&id=c7748706&scoped=true&external"
import script from "./manage-diagnosis.js?vue&type=script&lang=js&external"
export * from "./manage-diagnosis.js?vue&type=script&lang=js&external"
import style0 from "./manage-diagnosis.scss?vue&type=style&index=0&id=c7748706&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7748706",
  null
  
)

export default component.exports